import { styled } from '@mui/material/styles';
import { CheckIcon } from '@phosphor-icons/react/Check';
import { MinusIcon } from '@phosphor-icons/react/Minus';
import { MinusCircleIcon } from '@phosphor-icons/react/MinusCircle';
import { PlusIcon } from '@phosphor-icons/react/Plus';
import { XIcon } from '@phosphor-icons/react/X';

export const StyledBlockIcon = styled(MinusCircleIcon)`
  width: 24px;
  height: 18px;
  flex-shrink: 0;

  margin-right: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.error.main};
`;

export const StyledCheckIcon = styled(CheckIcon)`
  width: 24px;
  height: 18px;
  flex-shrink: 0;

  margin-right: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.success.main};
`;

export const StyledAddIcon = styled(PlusIcon)`
  width: 24px;
  height: 18px;
  flex-shrink: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledRemoveIcon = styled(MinusIcon)`
  width: 24px;
  height: 18px;
  flex-shrink: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledCloseIcon = styled(XIcon)`
  width: 24px;
  height: 18px;
  flex-shrink: 0;

  margin-right: ${({ theme }) => theme.spacing(1)};
`;
